import { Injectable } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import type { Requisition } from '@recruitee/requisitions-types';
import { RequisitionStatus } from '@recruitee/requisitions-types';

import {
  RequisitionsAbilities,
  RequisitionsDataProviderService,
} from '../../data/single-requisition/requisitions-data-provider.service';

@Injectable()
export class ApprovalFlowFacade {
  private requisition: Requisition;
  private abilities: RequisitionsAbilities;
  private isRequisitionReadOnly: boolean;
  private ngOnDestroy$ = new Subject<void>();

  constructor(protected requisitionsData: RequisitionsDataProviderService) {
    requisitionsData.data$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(({ requisition, abilities, isRequisitionReadOnly }) => {
        this.requisition = requisition;
        this.abilities = abilities;
        this.isRequisitionReadOnly = isRequisitionReadOnly;
      });
  }

  public get isFlowEditable(): boolean {
    const allowedStatuses = [
      RequisitionStatus.Draft,
      RequisitionStatus.Pending,
      RequisitionStatus.Rejected,
    ];
    return (
      this.abilities.manageRequisitions &&
      allowedStatuses.includes(this.requisition.status) &&
      !this.isRequisitionReadOnly
    );
  }

  public get canChangeFlow(): boolean {
    const allowedStatuses = [RequisitionStatus.Draft, RequisitionStatus.Rejected];
    return this.abilities.manageRequisitions && allowedStatuses.includes(this.requisition.status);
  }

  public get canSendReminders(): boolean {
    return this.abilities.manageRequisitions && !this.isRequisitionReadOnly;
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
